import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GoogleRecaptchaTheme } from 'src/app/constants/google-recaptcha';
import { TokenResponse } from 'src/app/models/auth';
import { AuthService } from 'src/app/services/auth.service';
import { SessionService } from 'src/app/services/storage/session.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'mwp-captcha-google',
    templateUrl: './captcha-google.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CaptchaGoogleComponent implements OnInit, OnDestroy {
    @Input() public form: FormGroup;
    @Input() public nameForRadioControl: string;
    @Input() public nameForRadioControlId: string;
    @Output() public emitReloadCaptcha: EventEmitter<boolean> = new EventEmitter<boolean>();

    public recaptchaKey = environment.googleCaptchaKey;
    public isRecaptchaLoaded: boolean;
    public recaptchaTheme: GoogleRecaptchaTheme;

    private nodeId: string = 'mwp-captcha-script';

    constructor(
        private renderer2: Renderer2,
        private sessionService: SessionService,
        private authService: AuthService,
        @Inject(DOCUMENT) private document: Document
    ) { 
        let node = document.createElement('script');
        node.id = this.nodeId;
        node.src = 'https://www.google.com/recaptcha/api.js';
        node.type = 'text/javascript';
        node.async = true;
        node.charset = 'utf-8';
        node.defer = true;
        this.renderer2.appendChild(this.document.body, node);

        (window as any)['recaptchaCallback'] = (responseKey: string) => {
            this.updateCaptcha(responseKey); 
        }

        (window as any)['recaptchaExpired'] = () => {
            this.resetForm();
        }
    }

    ngOnInit(): void {
        this.recaptchaTheme = this.sessionService.session.isDarkMode ? GoogleRecaptchaTheme.Dark : GoogleRecaptchaTheme.Light;
        this.isRecaptchaLoaded = true;
    }

    ngOnDestroy(): void {
        let node = document.createElement(this.nodeId);

        if(node)
            node.remove();
    }

    // By adding a listener outside of javascript base, execution of setValue and formValidation upate will not exextue.
    // Simple solution is to click a hidden button to trigger the form updatea
    public updateCaptcha(responseKey: string): void {
        const l_TokenResponse = new TokenResponse();
        l_TokenResponse.token = responseKey;
        l_TokenResponse.useSecondary = true;

        this.authService.captchaAuthentication(l_TokenResponse).subscribe(
                (response: TokenResponse) => {
                    if (response.forceReloadCaptcha) {
                        this.emitReloadCaptcha.emit(response.useSecondary);
                    } else {
                        this.form.get(this.nameForRadioControlId).setValue(response.id);
                        this.form.get(this.nameForRadioControl).setValue(responseKey);
                        this.form.updateValueAndValidity();
                    }
                },
                error => this.resetForm());
    }

    public resetForm(): void {
        this.form.get(this.nameForRadioControlId).setValue(null);
        this.form.get(this.nameForRadioControl).setValue(null);
        this.document.getElementById('recaptchaUpdateForm').click();
    }

    public updateForm(): void {
        this.form.updateValueAndValidity();
    }
}